import { ReactElement } from "react";
import { ITextInfosProps } from "./types";
import { Flex, Text, useMantineTheme } from "@mantine/core";
import { useStyles } from "./TextInfos.styled";

export default function TextInfos({
  text1,
  text2,
  text3,
  gap = "xs",
  ...flexProps
}: ITextInfosProps): ReactElement {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  return (
    <Flex
      direction={{
        base: "column",
        xs: "row",
      }}
      fw={700}
      gap={gap}
      {...flexProps}
    >
      {typeof text1 === "string" ? (
        <Text fz="sm" miw={{ base: "100%", xs: "22%" }}>
          {text1}
        </Text>
      ) : (
        <Flex
          align="center"
          direction="row"
          gap={theme.spacing.xs / 2}
          justify="flex-start"
          miw={{ base: "100%", xs: "22%" }}
        >
          {text1}
        </Flex>
      )}

      <Flex
        align="flex-end"
        direction="row"
        gap="xs"
        justify="space-between"
        w="100%"
      >
        {text2 && (
          <Text fw={400} fz="sm">
            {text2}
          </Text>
        )}

        {text3 && (
          <Text className={classes.flex} fz="sm" ml={{ xs: "xs" }} ta="right">
            {text3}
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
